import { useEffect, useState } from "react";

import useHasFeature from "@/features/useHasFeature";

const useIsAuthorizedForIndependentReadingChallenge = () => {
  const [isAuthorizedForIrc, setIsAuthorizedForIrc] = useState(false);
  const [canViewIrcFeatureEnabled] = useHasFeature("can_view_irc");
  useEffect(() => {
    setIsAuthorizedForIrc(canViewIrcFeatureEnabled);
  }, [canViewIrcFeatureEnabled]);
  return isAuthorizedForIrc;
};

export default useIsAuthorizedForIndependentReadingChallenge;
